import { createSelector, createFeatureSelector } from '@ngrx/store';
import { adapter } from './account.entity';
import { AccountState, accountFeatureKey } from './account.state';
import { Predicate } from '@ngrx/entity';
import { Account } from '../models/account';

export const { selectAll, selectEntities, selectIds, selectTotal } = adapter.getSelectors();

export const getAccountState = createFeatureSelector<AccountState>(accountFeatureKey);

export const getAllAccounts = createSelector(getAccountState, selectAll);

export const getAccountById = (id: string) => createSelector(getAccountState, (state) => state.entities[id]);

export const getAccountByFilter = (predicate: Predicate<Account>) =>
  createSelector(getAllAccounts, (x) => x.filter(predicate));

export const getError = createSelector(getAccountState, (state) => state.error);

export const getAccountFilter = createSelector(getAccountState, (state) => state.filter);

export const getCurrentAccount = createSelector(getAccountState, (state) => state.current);

export const getTotalCount = createSelector(getAccountState, (state) => state.totalCount);

export const getAccountBySearch = (predicate: Predicate<Account>) =>
  createSelector(getAllAccounts, (state) => state.find(predicate));

// tslint:disable-next-line: max-line-length
export const getCurrentAccountBySearch = (predicate: Predicate<Account>) =>
  createSelector(getCurrentAccount, (state) => state.find(predicate));

export const getBusinessAccount = createSelector(getCurrentAccount, (state) =>
  state.find((account) => account.type === 'BUSINESS' && account.userAccountType === 'Instructor')
);

export const getProviderBusinessAccount = createSelector(getCurrentAccount, (state) =>
state.find((account) => account.type === 'BUSINESS' && account.userAccountType === 'ServiceProvider')
);
export const getKycDocuments = createSelector(getAccountState, (state) => state.kycDocuments);
export const getBankAccount = createSelector(getAccountState, (state) => state.bankAccounts);
